<app-side-bar *ngIf="!isCabView" [callFromTrip]="false"></app-side-bar>
<app-side-view-cab *ngIf="isCabView" [callFromTrip]="false" [tripReplay]="true"></app-side-view-cab>